import { Controller } from 'stimulus';

export default class extends Controller {
  dismiss(e) {
    e.preventDefault();
    this.element.remove();
    fetch('/dismiss-promo-banner');
  }
}
